import { ref, computed, onMounted } from 'vue';

/**
 * Composable for managing token consumption warning banner
 * Reads from and writes to localStorage to persist across pages
 */
export const useTokenWarningBanner = () => {
  const warningLevel = ref('none'); // 'none', 'first', 'second'
  const tokenConsumptionPercent = ref(0);
  const isDismissed = ref(false);

  // Load from localStorage on mount
  onMounted(() => {
    const stored = localStorage.getItem('tokenWarningLevel');
    if (stored && stored !== 'none') {
      warningLevel.value = stored;
      const percent = localStorage.getItem('tokenWarningPercent');
      tokenConsumptionPercent.value = percent ? parseInt(percent) : 0;
      // Check if previously dismissed in this session
      isDismissed.value = sessionStorage.getItem('tokenWarningDismissed') === 'true';
    }
  });

  // Computed: should banner be visible?
  const shouldShowBanner = computed(() => {
    return warningLevel.value !== 'none' && !isDismissed.value;
  });

  // Dismiss banner: hide from view and mark in sessionStorage
  const dismissBanner = () => {
    isDismissed.value = true;
    sessionStorage.setItem('tokenWarningDismissed', 'true');
  };

  // Clear warning completely (called on logout or explicit clear)
  const clearWarning = () => {
    warningLevel.value = 'none';
    tokenConsumptionPercent.value = 0;
    isDismissed.value = false;
    localStorage.removeItem('tokenWarningLevel');
    localStorage.removeItem('tokenWarningPercent');
    sessionStorage.removeItem('tokenWarningDismissed');
  };

  return {
    warningLevel,
    tokenConsumptionPercent,
    isDismissed,
    shouldShowBanner,
    dismissBanner,
    clearWarning
  };
};
